/* eslint-disable no-unused-vars */

import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';

export const GET_ALL_PERMISSION_USERS_REQUEST = 'GET_ALL_PERMISSION_USERS_REQUEST';
export const GET_ALL_PERMISSION_USERS_SUCCESS = 'GET_ALL_PERMISSION_USERS_SUCCESS';
export const GET_ALL_PERMISSION_USERS_FAILURE = 'GET_ALL_PERMISSION_USERS_FAILURE';

export const CREATE_NEW_USER_REQUEST = 'CREATE_NEW_USER_REQUEST';
export const CREATE_NEW_USER_SUCCESS = 'CREATE_NEW_USER_SUCCESS';
export const CREATE_NEW_USER_FAILURE = 'CREATE_NEW_USER_FAILURE';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';

export const CHANGE_USER_STATUS_REQUEST = 'CHANGE_USER_STATUS_REQUEST';
export const CHANGE_USER_STATUS_SUCCESS = 'CHANGE_USER_STATUS_SUCCESS';
export const CHANGE_USER_STATUS_FAILURE = 'CHANGE_USER_STATUS_FAILURE';

// FIXME: this is a duplicate of fetchUserEmailsBySalon with only types field being different
export const getAllPermissionUsers = (salonId) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    authenticated: true,
    config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
    endpoint: `salon/${salonId}/users/`,
    types: [GET_ALL_PERMISSION_USERS_REQUEST, GET_ALL_PERMISSION_USERS_SUCCESS, GET_ALL_PERMISSION_USERS_FAILURE],
  },
});

export const createNewUser = (salonId, data) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    authenticated: true,
    config: { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) },
    endpoint: `salon/${salonId}/users/`,
    types: [CREATE_NEW_USER_REQUEST, CREATE_NEW_USER_SUCCESS, CREATE_NEW_USER_FAILURE],
  },
});

export const updateUser = (salonId, user) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    authenticated: true,
    config: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: user.id, user_type: user.user_type }),
    },
    endpoint: `salon/${salonId}/users/`,
    types: [UPDATE_USER_REQUEST, UPDATE_USER_SUCCESS, UPDATE_USER_FAILURE],
  },
});

export function changeUserStatus(salonId, user, action) {
  const config = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ user_id: user.id, action }),
  };
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `salon/${salonId}/profile/${user.id}/`,
      authenticated: true,
      types: [CHANGE_USER_STATUS_REQUEST, CHANGE_USER_STATUS_SUCCESS, CHANGE_USER_STATUS_FAILURE],
      config,
      params: {
        action,
        id: user.id,
      },
    },
  };
}

export function createAndGetUsers(salonId, data) {
  return (dispatch) => {
    dispatch(createNewUser(salonId, data)).then(({ response, type }) => {
      if (type !== CREATE_NEW_USER_SUCCESS) return;
      dispatch(getAllPermissionUsers(salonId));
    });
  };
}

// FIXME: seems unused, delete it
export function updateStatusAndGetUsers(salonId, user, action) {
  return (dispatch) => {
    dispatch(changeUserStatus(salonId, user, action)).then(({ response, type }) => {
      if (type !== CHANGE_USER_STATUS_SUCCESS) return;
      dispatch(getAllPermissionUsers(salonId));
    });
  };
}
